import React from 'react';
import { Table } from 'semantic-ui-react';
import { firstError, firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import TableHeader from '@/components/table/TableHeader';
import WorkspacesTableColumns from './WorkspacesTableColumns';

const WorkspacesTableHeader = ({
  category,
  children,
  columns,
  headerId,
  hideColumns,
  loaderButton,
  readErrors,
  readStatus,
  workspaces,
}) => (
  <Table.Header fullWidth>
    <TableHeader
      isLoading={readStatus.some((r) => (r === states.PENDING))}
      error={firstErrorMessage(readErrors)}
      headerId={firstError(readErrors) || readStatus.some((r) => (r === states.PENDING)) ? undefined : headerId}
      numberOfColumns={columns.length}
      loaderButton={loaderButton}
    >
      {children}
    </TableHeader>
    {!hideColumns && <WorkspacesTableColumns category={category} items={workspaces} columns={columns} />}
  </Table.Header>
);

export default WorkspacesTableHeader;
